define('components/decorators/billing',['jquery', 'components/util/clearbutton'], function($, clearButtonUtil) {
    $.extend(companyInfo.decorators, {
        'billing': function(e) {

            function formatDates(date) {
              return date.replace(/[./]/g,'-')
                  .split('-')
                  .reverse()
                  .join('-');
            }

            var billingForm = $('#billingForm');
            var clientSelect = billingForm.find('select#client'); // Billing reports
            var clientIdsSelect = billingForm.find('select#clientIdsSelect'); // Usage reports
            var startDate = billingForm.find('#dateStartBilling');
            var endDate = billingForm.find('#dateEndBilling');

            function validateForm() {
              var reportType = billingForm.find('#reportType').val();

              var startDateValid = validateField(startDate.val(), startDate);
              var endDateValid = validateField(endDate.val(), endDate);

              if (reportType === 'BILLING' && clientSelect.length) {
                var client = clientSelect.prev().find('a.select2-choice');
                if (!validateField(clientSelect.val(), client)) return false;
              }

              if (!startDateValid || !endDateValid) return false;
              if (!compareDates()) {
                $('#date-error').removeClass('hidden');
                return false;
              }

              return true;
            }

            function compareDates() { // End date must be after start date
              if (!startDate.val() || !endDate.val()) return false;
              var start = new Date(formatDates(startDate.val()));
              var end = new Date(formatDates(endDate.val()));
              return end >= start;
            }

            function validateField(val, element) {
              var $el = $(element);
              if (!val || val.length < 1) {
                $el.css('border', '1px solid red');
                return false;
              } else {
                $el.css('border', '2px solid #ccc');
                return true;
              }
            }

            clientSelect.on('change', function(e) { // Billing repots select
              var value = e.val;
              var client = clientSelect.prev().find('a.select2-choice');
              validateField(value, client);
            });

            clientIdsSelect.on('change', function(e) { // Usage reports select
              if (e.added && e.added.id === 'select-all') {
                $(this).select2('close');
              }
              if (e.removed && e.removed.id === 'select-all') { // If select all is removed, enable all options again
                $(this).find('option').each(function(i, el) {
                  $(el).prop('disabled', false);
                });
              }
            });

            clientIdsSelect.on('select2-close', function(e) {
              var select = $(this);
              if (!select.select2('val').length) return;
              if (select.select2('val')[0] === 'select-all') { // If select all is in selection disable all options
                select.find('option').each(function(i, el) {
                  if ($(el).val() !== 'select-all') {
                    $(el).prop('disabled', true);
                  }
                });
                select.select2('val', 'select-all'); // If select all is selected while multiselect has other values, only add select all as selection
              }
            });

            clientIdsSelect.on('select2-opening', function(e) {
              var select = $(this);
              var data = select.select2('data');
              if (data.length && data[0].id === 'select-all') { // Fix for not having Select All selectable after it's already selected, after POST
                select.find('option').eq(0).prop('selected', true);
              }
            });

            billingForm.on('change', function(e) {
                $('#date-error').addClass('hidden');
                clearButtonUtil.setClearInputFieldsIcons(billingForm);

                if (e.target.id === 'dateStartBilling' || e.target.id === 'dateEndBilling') {
                  validateField(e.target.value, e.target);
                }
            });

            billingForm.on('submit', function(e) {
               var form = $(this);
               if (!validateForm()) {
                  e.preventDefault();
                  e.stopImmediatePropagation(); // So we don't show loader on submit button
                  form.find('input[type=submit]').blur();
               }
               var clientIdsSelectValue = clientIdsSelect.select2('val');
               var startDateHidden = form.find('#startDate');
               var endDateHidden = form.find('#endDate');
               var startDateInputValue = form.find('#dateStartBilling').val();
               var endDateInputValue = form.find('#dateEndBilling').val();

               if (clientIdsSelectValue.length && clientIdsSelectValue[0] === 'select-all') {
                 clientIdsSelect.val([]); // If we send empty array that means that everything is selected
               }

               startDateHidden.val(formatDates(startDateInputValue));
               endDateHidden.val(formatDates(endDateInputValue));
            });
        }
    });

});
